export default __webpack_public_path__ + "static/media/2.SILOS.7d139b3b.jpg";